import React, { useState, useRef, useEffect } from "react";
import { format } from "date-fns";
import { RenderIcon } from "src/assets/icons";
import { cn } from "src/util/cn";
import DatePicker from "react-datepicker";
import "/node_modules/react-datepicker/dist/react-datepicker.css";



interface DateRangePickerProps {
  setDateRange?: (range?: { fromDate?: string; toDate?: string }) => void;
  dateRange?: { fromDate?: string; toDate?: string };
  onApply?: () => void;
  handleClearRange?: () => void;
  className?: string;
  initialValues?: any;
  openCustom?: any;
  handleUpdateRange?: (state?: any) => void;
  disabledDate?:any;
  setIsFilterDisabled?:any;
}

const DateRangePicker: React.FC<DateRangePickerProps> = ({
  setDateRange = () => {},
  dateRange,
  onApply = () => {},
  className,
  handleClearRange = () => {},
  initialValues = false,
  handleUpdateRange = () => {},
  openCustom = true,
  disabledDate,
  setIsFilterDisabled
}) => {
  
  const [newRange, setNewRange] = useState<[Date | null, Date | null]>([
    dateRange?.fromDate ? new Date(dateRange.fromDate) : null,
    dateRange?.toDate ? new Date(dateRange.toDate) : null,
  ]);

  
  const [isOpen, setIsOpen] = useState(false); // Track open state manually
  const datepickerRef = useRef<any>(null);



  const handleClick = () => {
    setIsOpen((prev) => !prev);
    if (datepickerRef.current) {
      datepickerRef.current.setOpen(!isOpen);
    }
  };

    const handleDateChange = (dates: [Date | null, Date | null]) => {
      setIsFilterDisabled(false);
    const [start, end] = dates;
  
    if (start && !end) {
      setNewRange([start, null]);
      setDateRange({
        fromDate: format(start, "yyyy-MM-dd"), 
        toDate: "",
      });
    } else if (start && end) {
      setNewRange([start, end]);
      setDateRange({
        fromDate: format(start, "yyyy-MM-dd"),
        toDate: format(end, "yyyy-MM-dd"),
      });
    }
  };
  
  
  const handleClear = () => {
    setNewRange([null,null]);
    setIsFilterDisabled(true);
  }

  const handleCalendarClose = () => {
    if (newRange[0] && !newRange[1]) {
      const sevenDaysLater = new Date(newRange[0]);
      sevenDaysLater.setDate(newRange[0]!.getDate() + 6);

      const endDate = sevenDaysLater > new Date() ? new Date() : sevenDaysLater;

      setNewRange([newRange[0], endDate]);
      setDateRange({
        fromDate: format(new Date(newRange[0]), "yyyy-MM-dd"),
        toDate: format(new Date(endDate), "yyyy-MM-dd"),
      });
    }
    setIsOpen(false);
  };

  useEffect(() => {
    if (dateRange?.fromDate && dateRange?.toDate) {
      setNewRange([new Date(dateRange.fromDate), new Date(dateRange.toDate)]);
    }
  }, [dateRange]);

  return (
    <>
      <div
        className={cn(
          "flex bg-[#2A2A2A] rounded-full justify-center items-start w-full  h-[40px] py-1 px-[14px] sm:px-[18px] hover:bg-[#343434] relative",
          className
        )}
      >
        <div
          onClick={handleClick}
          className="flex flex-col rounded-full w-full justify-start items-start cursor-pointer relative"
        >
          <span className="text-[#717171] text-[10px] leading-[14.2px] font-normal mr-4 font-popins">
            Time Period
          </span>
          <div className="flex-1 text-[13px] leading-[18.18px] font-normal text-[#FFFFFF] font-popins">
            {newRange[0] && newRange[1]
              ? `${format(newRange[0], "dd MMM yy")} - ${format(newRange[1], "dd MMM yy")}`
              : "Select Date Range"}
          </div>
        </div>
        {newRange[0] && newRange[1]&& (
          <div
            onClick={(e) => {
              e.stopPropagation();
              handleClear();
            }}
            aria-label="Clear Date Range"
            className="mt-[8px] md:mt-[7px] bg-[transparent] cursor-pointer"
          >
            <RenderIcon
              type="close"
              width={20}
              height={20}
              className="opacity-50"
            />
          </div>
        )}
        
            <DatePicker
              ref={datepickerRef}
              // selected={newRange}
              onChange={handleDateChange}
              startDate={newRange[0]}
              endDate={newRange[1]}
              minDate={new Date(disabledDate)}
              maxDate={new Date()}
              selectsRange
              monthsShown={2}
              shouldCloseOnSelect={true}
              customInput={<span />}
              open={isOpen}
              onCalendarOpen={() => setIsOpen(true)}
              onCalendarClose={handleCalendarClose}
              className="date-range-filter"
              popperClassName="!z-[9999]"
              popperProps={{ strategy: "fixed" }}
              calendarClassName="bg-[#1E1E1E] border border-gray-700 rounded-lg shadow-lg p-2 w-[720px] top-[80px] sm:top-[0px] sm:left-[140px]"
              dayClassName={(date) =>
                "hover:bg-[#0B0B0B] rounded-full text-white"
              }
            />
      </div>
    </>
  );
};

export default DateRangePicker;
